// @ts-strict-ignore
import React from 'react';
import { SubStep } from 'common/onboarding/immersive-onboarding/types';
export const EventSubStepContext = React.createContext<{
  eventSubStep: SubStep;
  setEventSubStep: React.Dispatch<React.SetStateAction<SubStep>>;
}>(null);